<app-carousel></app-carousel>
<!--<div class="content">
  <span>GP Automazioni</span>
</div>-->
